import { render, staticRenderFns } from "./MUITAction.vue?vue&type=template&id=1bb8224f&scoped=true"
import script from "./MUITAction.vue?vue&type=script&lang=js"
export * from "./MUITAction.vue?vue&type=script&lang=js"
import style0 from "./MUITAction.vue?vue&type=style&index=0&id=1bb8224f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb8224f",
  null
  
)

export default component.exports